import { ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export interface IOfferSummaryInfoItemProps {
  name: string;
  value?: string | number;
}

export const OfferSummaryInfoItem: React.FC<IOfferSummaryInfoItemProps> = ({ name, value }) => {
  return (
    <div data-testid="OfferSummaryInfoItem" className={styles['item']}>
      <ArticleParagraph1 color="gray60_100">{name}</ArticleParagraph1>
      <ArticleParagraph1 color="black_100">{value}</ArticleParagraph1>
    </div>
  );
};
